var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('legend', [_vm._v("Agent Prealert Dashboard")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(0), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('fromDate')
    },
    attrs: {
      "id": "fromDate",
      "type": "Date",
      "name": "fromDate"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.fromDate')),
      expression: "errors.has('form-2.fromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select From Date")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(1), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "id": "toDate",
      "type": "Date",
      "name": "toDate"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "change": function($event) {
        return _vm.onDateChange()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.toDate')),
      expression: "errors.has('form-2.toDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select To Date")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.processmode),
      expression: "processmode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('processmode')
    },
    attrs: {
      "name": "processmode",
      "id": "processmode"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.processmode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Process Mode")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Handover",
      "selected": ""
    }
  }, [_vm._v("Handover")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Return"
    }
  }, [_vm._v("Return")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.processmode')),
      expression: "errors.has('form-2.processmode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Process Mode")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('status')
    },
    attrs: {
      "name": "status",
      "id": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "All",
      "selected": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pending"
    }
  }, [_vm._v("Pending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PartialPending"
    }
  }, [_vm._v("Partial Pending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BatchClose"
    }
  }, [_vm._v("Batch Close")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Overage"
    }
  }, [_vm._v("Overage")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-2.status')),
      expression: "errors.has('form-2.status')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Status")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-input-group', {
    staticClass: "topspace"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAgentData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Export ")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger leftmar",
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" Reset ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-2"
  }, [_c('vue-element-loading', {
    staticStyle: {
      "background-color": "transparent"
    },
    attrs: {
      "spinner": "spinner",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])], 1)])])])])]), _vm._v(" "), (_vm.returnArray.length != 0) ? [_c('div', {}, [_c('legend', [_vm._v("Handover-Details")]), _vm._v(" "), _c('b-card', [_c('div', {
    class: {
      row: true,
      tableFixHead: true
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Batch ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Hub Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total Shipment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pending Inscan")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shortage")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Overage")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Handover")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Courier Company Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [(_vm.returnArray.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Records found")])]) : _vm._l((this.agentDetailss), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.hubname))]), _vm._v(" "), _c('td', [_c('span', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.getAgentShipmentDetails(data.batchid, data.handovermode, data.hubid)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(data.total_shipments))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pendinginscan))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shortage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.overage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.handover))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v(_vm._s(data.status))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.couriercompanyname))]), _vm._v(" "), (data.createddate) ? _c('td', [_vm._v(_vm._s(data.createddate.replace(/T/, " ")
      .replace(/\..+/, "")))]) : _vm._e()])
  })], 2)]), _vm._v(" "), (_vm.rowcount > 50) ? _c('div', [_c('paginate', {
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1) : _vm._e()])])], 1), _vm._v(" "), ((_vm.returnArray && _vm.returnArray.length != 0) && (_vm.agentShipmentDetails && _vm.agentShipmentDetails.length != 0)) ? _c('div', [_c('legend', [_vm._v("Shipment Details")]), _vm._v(" "), _c('b-card', [_c('div', {
    class: {
      row: true
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Batch ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehical Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Handover Person Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [((_vm.agentShipmentDetails == undefined && _vm.agentShipmentDetails.length == 0)) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("Agent shipment details not found.")])]) : _vm._e(), _vm._v(" "), _vm._l((this.agentShipmentDetails), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.batchid))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v(_vm._s(data.status))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.handovermode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.vehicleno))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.handoverpersonname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.process))]), _vm._v(" "), (data.createddate) ? _c('td', [_vm._v(_vm._s(data.createddate.replace(/T/, " ")
      .replace(/\..+/, "")))]) : _vm._e()])
  })], 2)])])])], 1) : _vm._e()] : _vm._e()], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("From Date"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("To Date"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Process Mode"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Status "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231375f0","hasScoped":true}!./src/views/components/agentHandoverDashboard/agentHandoverDashboard.component.html
// module id = 1043
// module chunks = 1